<template>
  <v-app :class="[isIos ? 'platform-ios' : '', isAndroid ? 'platform-android' : '']">
    <maintenance-page v-if="$store.getters.getMaintenanceMode" />
    <!-- <drawer v-if="showMenu()"></drawer> -->
    <app-header v-if="showMenu()"></app-header>
    <v-main v-resize="checkMobile" :class="[isIos ? 'ios-main' : '', isAndroid ? 'android-main' : '']">
      <!-- <v-banner v-if="company && appVersion && appVersion != 0 && app_version && appVersion != app_version" color="primary" dark class="text-center">
      {{ $t('app.new_version_message') }}
      <v-btn color="info" @click="reloadPage()">{{ $t('app.new_version_btn') }}</v-btn>
    </v-banner> -->
      <v-container fluid>
        <v-alert
          v-if="conversionActive"
          border="left"
          colored-border
          color="primary"
          elevation="2"
          dense
          icon="mdi-account-arrow-right"
          class="ma-2 mb-3"
        >
          <!-- Мульти-конвертации: строка на сессию; имя → карточка лида,
               «Продолжить» → воркспейс (или сразу NewBooking, если машина уже выбрана) -->
          <div v-for="s in conversions" :key="s.leadId" class="d-flex align-center flex-wrap mt-1" style="gap: 8px;">
            <span class="flex-grow-1">
              <i18n path="crm.convert.banner" tag="span">
                <template #name>
                  <router-link :to="`/crm/leads/${s.leadId}`" class="font-weight-bold text-decoration-none primary--text">{{ s.leadName || ("#" + s.leadId) }}</router-link>
                </template>
              </i18n>
              <span v-if="s.draft && s.draft.start && s.draft.end" class="text-caption grey--text ml-2">{{ s.draft.start }} — {{ s.draft.end }}<template v-if="s.draft.carName"> · {{ s.draft.carName }}</template></span>
            </span>
            <!-- Кнопки одной группой: всегда рядом по горизонтали (не переносятся
                 по одной), горизонтальный зазор между ними — 8px. -->
            <div class="d-flex align-center flex-shrink-0" style="gap: 8px;">
              <v-btn small outlined color="success" @click="resumeConversion(s)">
                <v-icon left small>mdi-play</v-icon>{{ $t('crm.convert.resume') }}
              </v-btn>
              <v-btn small outlined color="primary" @click="cancelConversion(s.leadId)">
                <v-icon left small>mdi-close</v-icon>{{ $t('crm.convert.cancel') }}
              </v-btn>
            </div>
          </div>
        </v-alert>
        <!-- Единый слот уведомлений (оплата/адрес/часовой пояс/демо/промо):
             один баннер за раз, приоритет и правила — в AnnouncementBar. -->
        <announcement-bar @remove-demo="removeDemoContent" @dismiss-telegram="closeBanner" />
        <!-- FT-070: paywall UX над billing_summary (soft/strong баннер + hard overlay). -->
        <billing-paywall
          @topup="transactionStart()"
          @rebind="$router.push({ path: '/transactions' }).catch(() => {})"
          @confirm="$router.push({ path: '/transactions' }).catch(() => {})"
          @subscribe="$router.push({ path: '/transactions' }).catch(() => {})"
          @iap-ios="openNativeTopup()"
          @iap-android="openNativeTopup()"
          @signout="signOut()"
        />
        <network-problem @retry="retryAfterNetworkProblem" />
        <!-- Жест «потяни, чтобы обновить»: только нативные сборки (в браузере свой). -->
        <pull-to-refresh v-if="isNative" :refresh="refreshFromPull" />
        <router-view :key="routerViewKey"></router-view>
        <!-- FT-191: общий компьютер — экран блокировки поверх страницы (она остаётся смонтированной)
             и оверлей вкладки, закрытой сменой сотрудника в другой вкладке. Только веб. -->
        <lock-screen v-if="!isNative && $store.getters['deviceLock/locked']" />
        <tab-closed-overlay v-if="!isNative && $store.getters['deviceLock/tabClosed']" />
        <pin-setup-dialog v-if="!isNative" />
        <!-- Тур отключён (2026-07-17): шаги завязаны на legacy-страницы /cars и /bookings,
             навигация переведена на /vehicles/list и /bookings/list. Вернуть после переработки. -->
        <!-- <tour></tour> -->
      </v-container>
      <!-- Удалить демо контент -->
      <v-overlay :value="showOverlayRemoveDemo">
        <v-card>
          <v-card-text>
            {{ $t("demo_content.removing_demo_content") }}
            <v-progress-linear class="mt-2" color="error accent-4" indeterminate rounded height="6"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-overlay>
    </v-main>
    <app-footer v-if="!isNative && showFooter()"></app-footer>
    <div v-else class="my-5"></div>
    <topup-dialog v-model="showTransactionDialog" />
    <passkey-nudge />
    <!-- Должникам: overlay перенесён в <billing-paywall> (FT-070, видимость = computed). -->
    <v-snackbar
      v-model="notification.show"
      data-testid="app-notification"
      :color="notification.color"
      :timeout="notification.timeout"
      :top="isMobile ? true : true"
      :right="isMobile ? false : true"
      :class="isIos ? 'ios-snackbar' : isMobile ? 'mt-5' : ''"
    >
      <div class="d-flex align-center">
        <v-icon
          class="mr-3"
          :color="notification.color === 'error' ? 'white' : ''"
        >
          {{ notification.icon }}
        </v-icon>

        <div>
          <div class="text-subtitle-1 font-weight-bold" data-testid="notification-title">{{ notification.title }}</div>
          <div v-if="notification.text" class="text-body-2" data-testid="notification-text">{{ notification.text }}</div>
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          @click="notification.show = false"
          :ripple="false"
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <app-version-check />
    <incoming-call-notices />
    <app-update-notifier />
  </v-app>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import IncomingCallNotices from "./components/IncomingCallNotices.vue";
import MaintenancePage from "./components/MaintenancePage.vue";
import { NotificationBus } from '@/plugins/notifications';
import AnnouncementBar from "./components/AnnouncementBar.vue";
import AppFooter from "./components/Footer.vue";
// Тур отключён (2026-07-17), см. комментарий у <tour> в шаблоне
// import Tour from "./components/Tour.vue";
import TopupDialog from "./components/TopupDialog.vue"; // FT-070: единый диалог пополнения
import purchaseService from '@/services/purchaseService';
import { Capacitor } from "@capacitor/core";
import { isVirtualDeviceOrFalse } from "@/utils/nativeDevice";
import PullToRefresh from "./components/common/PullToRefresh.vue";
import { refreshPage } from "@/utils/pullToRefresh";
import { StatusBar, Style } from "@capacitor/status-bar";
import AppVersionCheck from './components/AppVersionCheck.vue';
import AppUpdateNotifier from './components/AppUpdateNotifier.vue'; // PWA auto-update (web)
import BillingPaywall from "./components/BillingPaywall.vue"; // FT-070
import PasskeyNudge from "./components/common/PasskeyNudge.vue"; // FT-079
import NetworkProblem from "./components/common/NetworkProblem.vue";
import LockScreen from "./components/deviceLock/LockScreen.vue"; // FT-191
import TabClosedOverlay from "./components/deviceLock/TabClosedOverlay.vue"; // FT-191
import PinSetupDialog from "./components/deviceLock/PinSetupDialog.vue"; // FT-191
import CableReconnect from "@/mixins/CableReconnect";
import { markIntentionalLogout } from "@/utils/sessionExpiry";
import { forgetPushDevice } from "@/utils/pushDevice";
import moment from "moment";

export default {
  name: "App",
  mixins: [CableReconnect],
  metaInfo() {
    return {
      title: this.$t("custom.title_meta_1"),
      meta: [
        { name: "description", content: this.$t("custom.description_meta_1") },
        { property: "og:title", content: this.$t("custom.title_meta_1") },
        { property: "og:site_name", content: "CRM RentProg" },
        { property: "og:type", content: "website" },
        // robots здесь не задаём: noindex стоит статически в public/index.html.
        // vue-meta добавил бы второй тег, а не заменил статический.
      ],
    };
  },
  async beforeMount() {
    // iOS-симулятор — по Device.isVirtual, а не по слову Simulator в UA: в UA
    // его нет, и гейт никогда не срабатывал (ревью PR #433, utils/nativeDevice.js).
    // Сбой плагина = реальное устройство. Гейт по-прежнему только для iOS.
    const isSimulator = this.isNative && this.isIos && (await isVirtualDeviceOrFalse("App StatusBar"));

    if (isSimulator) {
      console.warn('StatusBar methods are not supported on iOS Simulator. Skipping initialization.');
    }
    
    if (this.isNative && !isSimulator) {
      const setupStatusBar = async () => {
        try {
          await StatusBar.setStyle({ style: Style.Light });
          await StatusBar.setOverlaysWebView({ overlay: true });
          if (this.isAndroid) {
            await StatusBar.setBackgroundColor({ color: '#00000000' }); // Прозрачный фон для Android
          }
        } catch (error) {
          // StatusBar methods are not supported on some platforms
          if (error.code !== 'UNIMPLEMENTED') {
            console.error('StatusBar setup error:', error);
          }
        }
      };
      setupStatusBar();
      if ($crisp && $crisp.push && typeof $crisp.push === 'function' && $crisp.on && typeof $crisp.on === 'function') {
        console.log('crisp $crisp.push(["safe", true])')
        $crisp.push(["safe", true]);
        const hideStatusBar = async () => {
          try {
            await StatusBar.hide();
          } catch (error) {
            // StatusBar.hide() is not supported on simulator
            if (error.code !== 'UNIMPLEMENTED') {
              console.error('StatusBar hide error:', error);
            }
          }
        };
        const showStatusBar = async () => {
          try {
            await StatusBar.show();
          } catch (error) {
            // StatusBar.show() is not supported on simulator
            if (error.code !== 'UNIMPLEMENTED') {
              console.error('StatusBar show error:', error);
            }
          }
        };
        $crisp.on("chat:opened", () => {
          console.log("chat:opened");
          hideStatusBar();
        });
        $crisp.on("chat:closed", () => {
          console.log("chat:closed");
          showStatusBar();
          // Натив: пузырь остаётся скрытым, чат открывается из меню «Поддержка».
          $crisp.push(["do", "chat:hide"]);
        });
      }
    }
  },
  async mounted() {
    if (
      this.$store.getters.getCurrentUser &&
      this.$store.getters.getCurrentUser != {} &&
      this.$store.getters.getSignedIn &&
      this.$route.name == "Home" &&
      !this.$store.getters.getCurrentUser.registration_tour &&
      this.$store.getters.getCompany &&
      this.$store.getters.getCompany.company &&
      this.$store.getters.getCompany.company.rental_object == "cars" &&
      this.$store.getters.getCompany.company.demo_content == true &&
      this.$tours["registrationTour"]
    ) {
      // this.$tours["registrationTour"].start();
    }
    // RevenueCat-идентификация вынесена в watch(rcMainCompanyId, immediate) —
    // чтобы отработать и когда MainCompany гидратируется в стор ПОСЛЕ mounted,
    // а не молча пропуститься (Vuex hydration race). См. methods.identifyRevenueCat.
  },
  components: {
    IncomingCallNotices,
    LockScreen,
    TabClosedOverlay,
    PinSetupDialog,
    AppHeader,
    MaintenancePage,
    AppFooter,
    AnnouncementBar,
    // Tour, — тур отключён (2026-07-17)
    AppVersionCheck,
    AppUpdateNotifier,
    BillingPaywall,
    TopupDialog,
    PasskeyNudge,
    NetworkProblem,
    PullToRefresh
  },
  created() {
    NotificationBus.$on('show-notification', ({ title, text, color, timeout, icon }) => {
      this.notification.title = title;
      this.notification.text = text;
      // Проверяем что color является строкой, иначе используем дефолтное значение
      this.notification.color = (typeof color === 'string' && color) ? color : 'success';
      this.notification.timeout = timeout;
      this.notification.icon = icon || 'mdi-check-circle';
      this.notification.show = true;
    });
  },
  updated() {
    if (
      this.$store.getters.getCurrentUser &&
      this.$store.getters.getCurrentUser != {} &&
      this.$store.getters.getSignedIn &&
      this.$route.name == "Home" &&
      !this.$store.getters.getCurrentUser.registration_tour &&
      this.$store.getters.getCompany &&
      this.$store.getters.getCompany.company &&
      this.$store.getters.getCompany.company.rental_object == "cars" &&
      this.$store.getters.getCompany.company.demo_content == true &&
      this.$tours["registrationTour"]
    ) {
      // тур отключён (см. комментарий у <tour> в шаблоне)
      // this.$tours["registrationTour"].start();
    }
  },
  data() {
    return {
      deferredPrompt: null,
      isMobile: false,
      // Инкремент ремаунтит текущий роут (кнопка «Повторить» сетевого баннера)
      routerViewKey: 0,
      app_version: process.env.VUE_APP_VERSION,
      showOverlayRemoveDemo: false,
      dontShowBalanceOverlay: false,
      showTransactionDialog: false,
      in_app_purchase_product: null,
      in_app_purchase_eur: 0,
      in_app_purchase_currency: null,
      in_app_purchase_price: null,
      in_app_purchase_start: false,
      notification: {
        show: false,
        title: '',
        text: '',
        color: 'success',
        timeout: 3000,
        icon: 'mdi-check-circle'
      },
      appId: 'ru.rentprog', // ID вашего приложения в Google Play
      appStoreId: '6444190825', // ID вашего приложения в App Store
      isLoading: false,
    };
  },
  watch: {
    // Идентифицируем RevenueCat, как только main_company попадает в стор
    // (в т.ч. если гидрация случилась ПОСЛЕ mounted). immediate закрывает
    // случай, когда стор уже гидратирован к моменту создания компонента.
    rcMainCompanyId: {
      immediate: true,
      handler() {
        this.identifyRevenueCat();
      },
    },
    // Держим <html lang> в соответствии с языком интерфейса. Первичное значение
    // ставит инлайн-скрипт в public/index.html (до рендера), здесь — поддержка при
    // переключении языка из Footer/Profile/Signup. Без этого браузер определяет язык
    // сам и предлагает перевести приложение: пользователь, согласившийся один раз,
    // видит машинный перевод поверх нашей локализации.
    "$i18n.locale": {
      immediate: true,
      handler(locale) {
        if (locale) document.documentElement.lang = locale;
      },
    },
  },
  computed: {
    rcMainCompanyId() {
      return this.$store.getters.getMainCompany?.id || null;
    },
    conversionActive() {
      return this.$store.getters["crm/conversionActive"];
    },
    conversions() {
      return this.$store.getters["crm/conversions"];
    },
    company() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.id) {
        return this.$store.getters.getCompany.company;
      } else {
        return {};
      }
    },
    appVersion() {
      return this.$store.getters.appVersion;
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    isAndroid() {
      return Capacitor.getPlatform().toLowerCase() == "android" ? true : false;
    },
    currency() {
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.currency) {
        return this.$store.getters.getMainCompany.currency;
      } else {
        return "EUR";
      }
    },
  },
  methods: {
    // «Повторить» на сетевом баннере: снимаем флаг и ремаунтим текущий роут —
    // его mounted() заново запускает все загрузчики страницы. Мутации (POST)
    // при этом не повторяются.
    retryAfterNetworkProblem() {
      this.$store.commit("network/SET_PROBLEM", false);
      this.routerViewKey += 1;
    },
    // Жест «потяни, чтобы обновить»: своя загрузка страницы или ремаунт
    // роута — тот же механизм, что у «Повторить» выше. Если на экране был
    // ввод, ремаунт его сотрёт — сначала спрашиваем.
    refreshFromPull() {
      return refreshPage({
        remount: () => {
          this.routerViewKey += 1;
        },
        confirmDiscard: () => this.$confirm({ title: this.$t("crm.confirm.unsaved_changes") }),
      });
    },
    // Идентификация пользователя в RevenueCat: appUserID = main_company_id + атрибуты.
    // Вызывается из watch(rcMainCompanyId, immediate) — устойчиво к Vuex-гонке.
    // setUserId самоидемпотентен, повторные срабатывания безопасны.
    async identifyRevenueCat() {
      const signedUser = this.$store.getters.getCurrentUser;
      const mainCompany = this.$store.getters.getMainCompany;
      if (!(this.isNative && mainCompany && mainCompany.id && signedUser && signedUser.email)) {
        return;
      }
      try {
        await purchaseService.setUserId(mainCompany.id.toString());
        await purchaseService.setAttributes({
          email: signedUser.email,
          displayName: signedUser.name || signedUser.email,
          phoneNumber: signedUser.phone || '',
          custom: {
            main_company_id: mainCompany.id.toString(),
            main_company_name: mainCompany.name || '',
            company_id: this.$store.getters.getCompany?.company?.id?.toString() || '',
            company_name: this.$store.getters.getCompany?.company?.name || '',
            plan: mainCompany.plan?.name || '',
            locale: signedUser.locale || this.$i18n.locale,
          },
        });
        console.log('RevenueCat identified, main_company_id:', mainCompany.id);
      } catch (error) {
        console.warn('RevenueCat identification failed:', error);
      }
    },
    cancelConversion(leadId) {
      this.$store.commit("crm/CLEAR_CONVERSION", leadId);
    },
    // «Продолжить»: машина уже выбрана → сразу NewBooking с датами/машиной/лидом;
    // иначе → воркспейс конвертации (даты восстановит из черновика сам).
    resumeConversion(s) {
      const d = s.draft || {};
      if (d.carId && d.start && d.end) {
        const fmt = (v) => moment(v, "DD-MM-YYYY H:mm").format("YYYY-MM-DDTHH:mm");
        const query = { car_id: d.carId, start_date: fmt(d.start), end_date: fmt(d.end), lead_id: s.leadId };
        if (s.clientId) query.client_id = s.clientId;
        this.$router.push({ name: "NewBooking", query }).catch(() => {});
      } else {
        this.$router.push(`/crm/leads/${s.leadId}/convert`).catch(() => {});
      }
    },
    // FT-070: только открытие — email-гард и весь префилл делает TopupDialog.vue в onOpen.
    transactionStart() {
      this.showTransactionDialog = true;
    },

    // IAP с блокирующего оверлея (BillingPaywall, native): уводим на «Транзакции».
    // Покупку сюда не тащим — она неотделима от Transactions.vue (schedule_verification,
    // onTopupPaid, перечитывание баланса). hardBlock снят ровно на этом маршруте, поэтому
    // переход и разблокирует экран, и открывает карточку баланса с рабочей IAP-кнопкой.
    //
    // Прежде тут стояли обёртки startInAppPurchaseIos/Android → this.startInAppPurchase(),
    // а метод удалён из App.vue коммитом 783dde88 (FT-070): на нативе оверлей прячет
    // веб-CTA и перекрывает хедер, так что должник не мог ни заплатить, ни уйти на
    // /transactions. Рубеж против повтора — tests/unit/danglingComponentMethods.spec.js.
    openNativeTopup() {
      this.$router.push({ name: "Transactions" }).catch(() => {});
    },
    showMenu() {
      if (
        this.$route.path == "/signin" ||
        this.$route.path == "/signup" ||
        this.$route.path == "/result_success" ||
        this.$route.path == "/result_bad" ||
        this.$route.path == "/forgot_password" ||
        this.$route.name == "ResetPassword" ||
        this.$route.name == "ClientPage" ||
        this.$route.name == "ClientResult" ||
        this.$route.path == "/404"
      ) {
        return false;
      } else {
        return true;
      }
    },
    showFooter() {
      if (this.$route.name == "ClientPage" || this.$route.name == "ClientResult") return false;
      return this.$route.name != "NewCalendar" || !this.isMobile;
    },
    closeBanner() {
      let self = this;
      this.$store.commit("setShowBanner", false);
      this.axios
        .patch(
          `/api/v1/users/${self.$store.getters.getCurrentUser.id}`,
          {
            users: {
              show_telegram: false,
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .catch((error) => {
          self.setError(error, self.$t("errors.profile_update"));
        })
        .finally(() => (self.isLoading = false));
    },
    removeDemoContent() {
      let self = this;
      this.$confirm({
        title: this.$t("custom.you_sure_title"),
        text: this.$t("demo_content.remove_demo_content_text"),
        icon: "mdi-alert-circle-outline",
        confirmButtonText: this.$t("custom.you_sure_yes"),
        cancelButtonText: this.$t("custom.you_sure_no"),
      }).then((result) => {
        if (result) {
          this.showOverlayRemoveDemo = true;
          if (self.$store.getters.getCompany && 
              self.$store.getters.getCompany.company && 
              self.$store.getters.getCompany.company.id) {
            this.axios
              .post(`/api/v1/remove_demo_content`,
                {
                  company_id: self.$store.getters.getCompany.company.id,
                },
                {
                  headers: {
                    Authorization: self.$store.getters.getAuthToken,
                  },
                })
              .then(() => {
                this.$store.commit("setBannerRemoveDemoContent", false);
                setTimeout(() => {
                  self.showOverlayRemoveDemo = false;
                  self.$notify(self.$t("custom.deleted"), self.$t("demo_content.remove_demo_content_success"), "success");
                  self.$router.go(0);
                }, 2000);
              })
              .catch((error) => {
                self.showOverlayRemoveDemo = false;
                self.setError(error, self.$t("errors.error"));
                console.log(error);
              });
          }
        }
      });
    },
    reloadPage() {
      window.location.reload(true);
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    signOut() {
      // FT-191 REQ-05: на общем компьютере «Выйти» из любого меню — блокировка, а не выход.
      if (this.$store.getters["deviceLock/deviceMode"]) {
        this.$store.dispatch("deviceLock/lock");
        return;
      }
      let self = this;
      
      // Logout from RevenueCat
      if (this.$store.getters.getCurrentUser && this.$store.getters.getCurrentUser.email && this.isNative) {
        purchaseService.logout().catch(err => {
          console.warn('RevenueCat logout failed:', err);
        });
      }
      
      // FT-136: выход обязан состояться локально при ЛЮБОМ исходе запроса. Раньше
      // мутация стояла только в `.then`, а на неуспехе разлогинивал интерсептор —
      // теперь он этого не делает (вердикт на намеренном выходе ложен по построению),
      // и без терминальной ветки человек остался бы залогиненным.
      // Устройство пушей — до sign_out: после отзыва JWT запрос не авторизовать.
      forgetPushDevice(this)
        .then(() =>
          this.axios(
            markIntentionalLogout({
              url: "users/sign_out",
              baseURL: this.$store.getters.getApiUrl, // FT-018: getter всегда non-null
              method: "delete",
              headers: { Authorization: self.$store.getters.getAuthToken },
            })
          )
        )
        .catch((error) => {
          // 401 здесь означает лишь, что токен и так был мёртв: выход удался, показывать
          // нечего. Прочие исходы — законная ошибка, о ней сообщаем как раньше.
          if (!(error && error.response && error.response.status === 401)) {
            self.setError(error, self.$t("errors.sign_out_unconfirmed"));
            // setError молчит на транзиентных сетевых обрывах (их индицирует баннер) — а
            // здесь молчать нельзя: именно при обрыве отзыв токена точно не состоялся.
            // Прямой $notify гарантирует предупреждение при любом не-401 исходе; на 5xx
            // он перезаписывает общий тост setError — последний вызов в снекбаре побеждает.
            self.$notify(self.$t("errors.attention"), self.$t("errors.sign_out_unconfirmed"), "warning", 6000);
          }
        })
        .finally(() => {
          self.isLoading = false;
          self.$store.commit("unsetCurrentUser");
        });
    },
  },
};
</script>

<style lang="less">

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }

  &.info {
    .tooltip-inner {
      background: rgba(#004499, 0.9);
      color: white;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }

    .tooltip-arrow {
      border-color: rgba(#004499, 0.9);
    }
  }

  &.popover {
    .popover-inner {
      background: #f9f9f9;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }

    .popover-arrow {
      border-color: #f9f9f9;
    }
  }
}

:root {
  --safe-area-top: env(safe-area-inset-top, 0px);
  --safe-area-bottom: env(safe-area-inset-bottom, 0px);
  --app-bar-height: 64px; /* Значение по умолчанию для десктопа */
  --status-bar-height: 0px; /* Для веб и десктопа */
}

/* Оверлеи (дроверы, полноэкранные диалоги) Vuetify рендерит вне v-main,
   поэтому классы android-main/ios-main их не достают. На Android при
   edge-to-edge (WebView 140+, Capacitor 8 отдаёт инсеты в страницу) они
   упирались в самый верх экрана — под статус-бар. env() = 0 в браузере
   и на старых WebView (там вьюху двигает натив), правила самонейтрализуются. */
.platform-android .v-navigation-drawer--temporary,
.platform-android .v-navigation-drawer--is-mobile {
  padding-top: var(--safe-area-top) !important;
  padding-bottom: var(--safe-area-bottom) !important;
}

.platform-android .v-dialog--fullscreen > .v-card {
  padding-top: var(--safe-area-top) !important;
}

/* То же для iOS. Точечные isIos-хаки в компонентах эту дыру не закрывали:
   :style на <v-dialog> Vue кладёт на корневой .v-dialog__container, а видимое
   содержимое (.v-dialog__content) миксин detachable уносит в [data-app] — отступ
   доставался пустому контейнеру. Селектор тот же, что у Android: у всех 22
   fullscreen-диалогов прямой потомок — v-card. */
.platform-ios .v-dialog--fullscreen > .v-card {
  padding-top: var(--safe-area-top) !important;
}

/* Три диалога держат в шапке цветной v-toolbar (gantt-календарь, просмотр фото
   повреждения, график эффективности). Отступ на карточке оставлял бы над цветной
   шапкой полосу фона карточки — переносим его на сам тулбар, чтобы его цвет заливал
   вырез, как это уже делает .ios-appbar. Отрицательный margin гасит отступ карточки,
   собственный padding опускает содержимое; height: auto нужен, потому что Vuetify
   пишет высоту тулбара инлайном (48px dense / 64px обычный), а .v-toolbar__content
   свою высоту сохраняет — при safe-area = 0 auto даёт ровно её, правило
   самонейтрализуется. Сумма высот не меняется, содержимое ниже не сдвигается. */
.platform-ios .v-dialog--fullscreen > .v-card > .v-toolbar:first-child {
  height: auto !important;
  margin-top: calc(-1 * var(--safe-area-top)) !important;
  padding-top: var(--safe-area-top) !important;
}

/* Медиа-запрос для мобильных устройств */
@media (max-width: 768px) {
  :root {
    --app-bar-height: 56px;
  }
}

/* Стили для iOS - сохраняем оригинальные */
.ios-main {
  padding-top: calc(var(--app-bar-height) + var(--safe-area-top)) !important;
}

/* Стили для Android — env(safe-area-inset-top): 0 на старых WebView (<140,
   Capacitor сам двигает WebView под статус-бар), реальная высота на новых
   (Capacitor отдаёт инсеты в страницу при viewport-fit=cover) */
.android-main {
  padding-top: calc(var(--app-bar-height) + var(--safe-area-top)) !important;
}

/* Стили для v-app-bar на iOS */
.v-application .v-app-bar.ios-appbar {
  height: calc(var(--app-bar-height) + var(--safe-area-top)) !important;
  padding-top: var(--safe-area-top) !important;
}

/* Стили для v-app-bar на Android — та же env-схема, что и iOS */
.v-application .v-app-bar.android-appbar {
  height: calc(var(--app-bar-height) + var(--safe-area-top)) !important;
  padding-top: var(--safe-area-top) !important;
}

/* Убираем старый отступ */
.v-main {
  margin-top: 0 !important;
}

/* Snackbar для iOS */
.ios-snackbar {
  top: calc(env(safe-area-inset-top, 0px) + 8px) !important;
  position: fixed !important;
}

.ios-dialog {
  padding-top: calc(env(safe-area-inset-top, 0px) + 8px) !important;
}

/* Общие стили для всех диалогов на Android */
.android-main .v-dialog {
  margin-top: var(--safe-area-top) !important;
}

/* Модалка Uppy (аватар пользователя и авто — Dashboard с inline: false) живёт вне
   дерева оверлеев Vuetify и позиционируется от края вьюпорта: .uppy-Dashboard-inner
   прибит к top: 35px, а крестик закрытия — к top: -33px над ним, то есть к 2px от
   верха экрана. При viewport-fit=cover это полоса чёлки/Dynamic Island — крестик
   уходит под неё и не нажимается. Свою safe-area Uppy не знает, правила выше
   достают только оверлеи Vuetify. Двигаем всю модалку: env() = 0 в браузере и на
   старых WebView, там правило самонейтрализуется. Десктопную раскладку модалки
   (у Uppy — min-width: 820px, центрирование через transform) не трогаем. */
@media only screen and (max-width: 819px) {
  .uppy-Dashboard--modal .uppy-Dashboard-inner {
    top: calc(35px + var(--safe-area-top)) !important;
    bottom: calc(15px + var(--safe-area-bottom)) !important;
  }
}

/* Встроенный Dashboard Uppy (все загрузчики с inline: true) вылезал поверх диалогов
   и меню Vuetify: шапка «Загрузка завершена», полоса статуса и кнопки файла рисовались
   над открытым просмотром документа. Внутренние элементы Dashboard позиционированы с
   z-index 1001–1005, а своего контекста наложения у встроенного Dashboard нет — эти
   значения спорят напрямую с .v-dialog__content (202) и выигрывают. isolation запирает
   их внутри загрузчика. Модалку (аватары, inline: false) не трогаем: ей положено быть
   поверх всего. Сторож — tests/unit/styles/uppyInlineStacking.spec.js. */
.uppy-Dashboard:not(.uppy-Dashboard--modal) {
  isolation: isolate;
}

/* Отступ для fullscreen диалогов на мобильных - чтобы кнопки не попадали под нативную навигацию Android */
@media (max-width: 600px) {
  .v-dialog--fullscreen .v-card__actions {
    padding-bottom: 48px !important;
  }
}
</style>
